var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 84,
    viewBox: "0 0 67 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8408 42.1211C53.6051 42.334 51.8485 43.4518 50.3048 44.9955C47.6965 47.657 45.035 50.3185 42.0541 53.2994C42.0541 52.0219 42.0541 51.2767 42.0541 50.5847C42.0541 37.2239 42.0541 23.9163 42.0541 10.5555C42.0541 9.43769 42.0009 8.26663 41.788 7.20202C40.9363 2.51776 36.252 -0.676059 31.621 0.122395C26.8835 0.97408 24.0091 4.54051 24.0091 9.81031C24.0091 23.4373 24.0091 37.011 24.0091 50.6379C24.0091 51.3299 24.0091 52.0219 24.0091 53.3527C20.9749 50.2653 18.3667 47.6038 15.7051 44.9955C11.8726 41.1629 6.33662 41.0565 2.71696 44.6229C-1.00916 48.2958 -0.902697 53.7785 3.03634 57.7176C10.7547 65.4892 18.5264 73.2076 26.2447 80.9259C30.3435 85.0247 35.6665 85.0247 39.8185 80.9259C44.2366 76.5078 48.6547 72.0897 53.0728 67.6716C56.4795 64.2649 59.9395 60.8581 63.3462 57.3982C66.2207 54.4173 66.8594 50.4782 65.0496 46.965C63.293 43.5051 59.833 41.642 55.8408 42.1211Z",
    fill: "url(#paint0_linear_63_157)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_63_157",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.96c964b3379218f35f98d65466db7dde.svg";
export { ForwardRef as ReactComponent };